import axios from "@/plugins/axios";

export function getBlogListByTagName(tagName, pageNum, pageSize) {
  return axios({
    url: "Article/GetPageList",
    method: "GET",
    params: {
      tagName,
      pageNum,
      pageSize,
    },
  });
}

export function getBlogTag() {
  return axios({
    url: "Tag/GetTagAsync",
    method: "GET",
  });
}
